import { FP_RECOMMENDATION } from "@/config/api";
import { styleName } from "@/config/const";
import { GetFpSiteName } from "@/shared/appInit";
import { HttpRequest } from "@/shared/request";
import { TResponse, TRecommendation, TStore, TAppStore } from "@/shared/types";
import { getCocktailByIds, getConsumerId, getSessionToken, interaction } from "@/shared/utils";

export async function getRecommendation(params: {
    appStore: TAppStore,
    storeConfig: TStore
}) {
    const { appStore, storeConfig } = params;
    const { answer, setResults, setSecondResults, alcohol } = appStore;
    const { storeStyleName, id, secondSitename, nonAlcoholStore } = storeConfig;
    if (!answer.atmosphere || answer.recipes.length < 3) {
        return
    }
    return new Promise((resolve) => {
        const requests = []
        const siteIds: string[] = []
        if (storeStyleName === styleName.Tanqueray) {
            requests.push(getCocktailRecommendations({
                Occasion: [answer.atmosphere],
                Recipes: answer.recipes,
                SiteId: GetFpSiteName(id),
                SessionToken: getSessionToken(),
                interactionType: 'View'
            }))
            siteIds.push(GetFpSiteName(id))
            if (secondSitename?.id) {
                requests.push(getCocktailRecommendations({
                    Occasion: [answer.atmosphere],
                    Recipes: answer.recipes,
                    SiteId: GetFpSiteName(secondSitename.id),
                    SessionToken: getSessionToken(),
                    interactionType: 'View'
                }))
                siteIds.push(GetFpSiteName(secondSitename.id))
            }
        } else {
            requests.push(getCocktailRecommendations({
                Occasion: [answer.atmosphere],
                Recipes: answer.recipes,
                SiteId: GetFpSiteName((!nonAlcoholStore?.id) ? id : alcohol ? id : nonAlcoholStore?.id),
                SessionToken: getSessionToken(),
                interactionType: 'View'

            }))
            siteIds.push(GetFpSiteName((!nonAlcoholStore?.id) ? id : alcohol ? id : nonAlcoholStore?.id))
        }
        Promise.allSettled(requests).then((res) => {
            const [primaryResults, secondResults] = res

            if (primaryResults.status === 'fulfilled') {
                const { success, data } = primaryResults.value.data
                if (success && data.cocktailRecommendations) {
                    const consumerId = data.consumerId as string
                    // interaction(answer.recipes, siteIds[0], consumerId, 'View')
                    interaction(data.cocktailRecommendations.map(item => item.cocktailId), siteIds[0], consumerId, 'Recommended')
                    getCocktailByIds(data.cocktailRecommendations.map(item => item.cocktailId)).finally(() => {
                        setResults(data)
                    })
                }
            }
            if (secondResults && secondResults.status === 'fulfilled') {
                const { success, data } = secondResults.value.data
                if (success && data.cocktailRecommendations) {
                    const consumerId = data.consumerId as string
                    // interaction(answer.recipes, siteIds[1], consumerId, 'View')
                    interaction(data.cocktailRecommendations.map(item => item.cocktailId), siteIds[1], consumerId, 'Recommended')
                    getCocktailByIds(data.cocktailRecommendations.map(item => item.cocktailId), 'secondCocktailList').finally(() => {
                        setSecondResults(data)
                    })
                }
            }
            if (requests.length === 2) {
                resolve(true)
            }
        })
    })
}
async function getCocktailRecommendations(params: any) {
    return await HttpRequest.post<TResponse<TRecommendation>>(FP_RECOMMENDATION, params)
}